import {
  GET_ACCOUNT,
  GET_USERS,
  GET_USER,
} from './../../mutation-types';

export default {
  [GET_ACCOUNT](state, account) {
    state.email = account.email;
    state.firstName = account.firstName;
    state.lastName = account.lastName;
  },
  [GET_USERS](state, data) {
    state.userlist = data;
  },
  [GET_USER](state, data) {
    state.edituser = data;
    if (data.roles) {
      for (let i = 0; i < data.roles.length; i += 1) {
        if (data.roles[i] === 'admin') {
          state.edituser.roles_admin = true;
        }
        if (data.roles[i] === 'profiles') {
          state.edituser.roles_profiles = true;
        }
        if (data.roles[i] === 'lists') {
          state.edituser.roles_lists = true;
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/account/mutations.js